import { useCallback, useContext } from 'react';
import api from 'api';
import downloadService from 'services/downloadService';
import DownloadStatusContext from 'providers/DownloadStatus/DownloadStatus.context';

export default function useStartDownloadingFile() {
  const { startFileDownload, failFileDownload } =
    useContext(DownloadStatusContext);

  return useCallback(
    async (nodeId: string) => {
      try {
        startFileDownload();
        await api.dataRoom.nodes.startDownloadingFile(
          nodeId,
          downloadService.downloadUniqueId,
        );
      } catch {
        failFileDownload();
      }
    },
    [failFileDownload, startFileDownload],
  );
}
